import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import AdminNav from "@/components/AdminNav";
import "@/styles/portfolio.css";
import "@/styles/admin.css";

const TILES = [
  {
    to: "/admin/posts",
    label: "Blog",
    hint: "Beiträge schreiben, bearbeiten, veröffentlichen",
    key: "posts",
    countLabel: "Beiträge",
  },
  {
    to: "/admin/deliveries",
    label: "Übergaben",
    hint: "Video-Delivery-Links für Kunden erstellen",
    key: "deliveries",
    countLabel: "aktive Links",
  },
  {
    to: "/admin/reels",
    label: "Reels",
    hint: "Beispiel-Reels für die Startseite pflegen",
    key: "reels",
    countLabel: "veröffentlicht",
  },
  {
    to: "/admin/testimonials",
    label: "Rezensionen",
    hint: "Kundenstimmen für das Karussell",
    key: "testimonials",
    countLabel: "veröffentlicht",
  },
  {
    to: "/admin/logos",
    label: "Kundenlogos",
    hint: "Logos für den Marquee-Banner",
    key: "logos",
    countLabel: "Logos",
  },
];

export default function AdminHome() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [counts, setCounts] = useState({});
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const [posts, del, reels, tst, logos] = await Promise.all([
          api.get("/admin/posts"),
          api.get("/admin/deliveries"),
          api.get("/admin/reels"),
          api.get("/admin/testimonials"),
          api.get("/admin/logos"),
        ]);
        setCounts({
          posts: posts.data.length,
          deliveries: del.data.filter((d) => d.active && !d.expired).length,
          reels: reels.data.filter((r) => r.published !== false).length,
          testimonials: tst.data.filter((t) => t.published !== false).length,
          logos: logos.data.length,
        });
      } catch (e) {
        setError(formatApiError(e));
      }
    })();
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="admin-shell" data-testid="admin-home">
      <header className="admin-header">
        <div>
          <span className="eyebrow">ADMIN · DASHBOARD</span>
          <h1 className="display admin-h1">
            Hi <span className="italic">{user?.name || "Max"}</span>.
          </h1>
          <p className="admin-subtitle">Was möchtest du heute anpacken?</p>
        </div>
        <button type="button" onClick={handleLogout} className="btn btn--ghost">
          <span>Abmelden</span>
        </button>
      </header>

      <AdminNav active="/admin" />

      {error && <div className="admin-error">{error}</div>}

      <section className="admin-grid" data-testid="admin-tiles">
        {TILES.map((t) => (
          <Link
            key={t.to}
            to={t.to}
            className="admin-tile"
            data-testid={`tile-${t.key}`}
          >
            <span className="admin-tile__count">
              {counts[t.key] ?? "—"}
            </span>
            <span className="admin-tile__count-label">{t.countLabel}</span>
            <h2 className="admin-tile__title">{t.label}</h2>
            <p className="admin-tile__hint">{t.hint}</p>
            <span className="admin-tile__arrow">→</span>
          </Link>
        ))}
      </section>
    </div>
  );
}
